import { Typography } from '@mui/material'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { formatRelativeTime } from 'utils/executive.utils'
import type { ExecutiveState } from 'app/slice/executive.slice'

export default function LastUpdatedBadge() {
  const { t } = useTranslation()
  const lastRefreshAt = useSelector(
    (s: { executive: ExecutiveState }) => s.executive.lastRefreshAt
  )
  const [, setTick] = useState(0)

  useEffect(() => {
    const id = setInterval(() => setTick((n) => n + 1), 30_000)
    return () => clearInterval(id)
  }, [])

  return (
    <Typography variant="caption" color="text.secondary">
      {t('EXECUTIVE.HEADER.UPDATED_AGO', { time: formatRelativeTime(lastRefreshAt) })}
    </Typography>
  )
}
